import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material"
import { EAN_LENGTH, MAX_EMAIL_LENGTH } from "../../../../../../../constants/inputValidationDefaults"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { BillReceiverType } from "../../../../organization/userGroups/userGroupsTypes"
import { SendInvoiceCompany } from "../../billReceiversTypes"

const useStyles = makeStyles()(() => ({
    dialogSubtitle: {
        marginBottom: "1rem",
    },
    input: {
        width: "10rem",
    },
}))

type SelectUserGroupDropdownProps = Readonly<{
    onSearchCall: (value: SendInvoiceCompany) => void
}>

export function SendInvoiceCompanySection({ onSearchCall }: SelectUserGroupDropdownProps) {
    const { classes } = useStyles()
    const [search, setSearch] = useState("")
    const [invoiceType, setInvoiceType] = useState(BillReceiverType.EMAIL_ADDRESS)

    const label = invoiceType === BillReceiverType.EMAIL_ADDRESS ? "Email" : "EAN Number"
    const localizedKey =
        invoiceType === BillReceiverType.EMAIL_ADDRESS
            ? "bill-receivers-input-search-label-email"
            : "bill-receivers-input-search-label-ean-number"
    const type = invoiceType === BillReceiverType.EMAIL_ADDRESS ? "email" : "text"
    const maxLength = invoiceType === BillReceiverType.EMAIL_ADDRESS ? MAX_EMAIL_LENGTH : EAN_LENGTH

    const onNextClick = () => {
        onSearchCall({
            invoiceType,
            search,
        })
    }

    return (
        <Grid container direction="column" wrap="nowrap">
            <LocalizedStrict id="bill-receivers-send-invoice">
                <Typography className={classes.dialogSubtitle} variant="subtitle1" textAlign="start">
                    Send invoice to:
                </Typography>
            </LocalizedStrict>
            <Stack direction="row" spacing="1rem">
                <FormControl className={classes.input}>
                    <LocalizedStrict id="bill-receivers-select-label-input-type">
                        <InputLabel id="type-select-label">Type</InputLabel>
                    </LocalizedStrict>
                    <LocalizedStrict id="bill-receivers-dropdown-type" attrs={{ label: true }}>
                        <Select
                            labelId="type-select-label"
                            id="type-select"
                            value={invoiceType}
                            label="Type"
                            onChange={(e) => {
                                setInvoiceType(e.target.value as BillReceiverType)
                            }}
                        >
                            <MenuItem value={BillReceiverType.EMAIL_ADDRESS}>
                                <LocalizedStrict id="bill-receivers-select-item-email">
                                    <span>Email</span>
                                </LocalizedStrict>
                            </MenuItem>
                            <MenuItem value={BillReceiverType.EAN_NUMBER}>
                                <LocalizedStrict id="bill-receivers-select-item-ean-number">
                                    <span>EAN Number</span>
                                </LocalizedStrict>
                            </MenuItem>
                        </Select>
                    </LocalizedStrict>
                </FormControl>
                <LocalizedStrict id={localizedKey} attrs={{ label: true }}>
                    <TextField
                        name="search"
                        value={search}
                        type={type}
                        label={label}
                        onChange={(e) => setSearch(e.target.value)}
                        inputProps={{
                            maxLength: maxLength,
                        }}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="bill-receivers-button-next">
                    <StandardButton
                        disabled={!search.trim()}
                        defaultBorderRadius
                        color="blue"
                        onClick={onNextClick}
                        fullWidth={false}
                    >
                        Next
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
        </Grid>
    )
}
